<div :class="['page', getActiveModal]">
    <div class="container">  
        <div class="grid">
            <div class="grid__container">
                <loader v-if="performers.status === 'fetching'" v-for="id in DEFAULT_LIMIT" :key="`loader-${id}`" />
                <template v-else v-for="(id, index) in performers.items" :key="id">                  
                    <tile :id="id" colums="grid__tile col-xs-2 col-sm-4 col-md-5" :index="index" :page="props.page" link="profile" />                                    
                </template>
            </div>
            <pager v-model="page" :limit="props.limit" :offset="props.offset" :total="performers.total"></pager>
        </div>
    </div>
</div>
